import type { ReactNode } from 'react';

import Image from 'next/image';

import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { Image as Pic } from '@gds/Icons/Paths/Image';
import RacLogo from '@gds/RacBadge/rac.webp';

import { VehicleHeroImage } from './VehicleHeroImage/VehicleHeroImage';

import styles from './HeroImage.module.css';

const IMAGE_SIZE = 70;

export const HeroImage = ({
  image,
  index,
  isRacApproved,
  totalImages,
  makeModelLabel,
  isInactive,
  preloadLimit,
  comingSoonSlot,
}: {
  vehicle?: Vehicle;
  image: VehicleImage;
  index?: number;
  isRacApproved?: boolean;
  totalImages?: number;
  makeModelLabel: string;
  isInactive?: boolean;
  preloadLimit?: number;
  comingSoonSlot: ReactNode;
}) => {
  const logoSrc = isRacApproved ? RacLogo : null;
  const logoAlt = isRacApproved ? 'rac approved logo' : '';
  return (
    <figure className={styles.wrpr}>
      {image && (totalImages === undefined || totalImages > 0) ? (
        <VehicleHeroImage
          image={image}
          index={index}
          makeModelLabel={makeModelLabel}
          isInactive={isInactive}
          preloadLimit={preloadLimit}
        />
      ) : (
        comingSoonSlot
      )}

      {logoSrc && (
        <aside className={styles.racBadge}>
          <Image src={logoSrc} width={IMAGE_SIZE} height={IMAGE_SIZE} alt={logoAlt} />
        </aside>
      )}

      {totalImages && (
        <aside className={styles.imgsNum}>
          <Pic />
          {totalImages}
        </aside>
      )}
    </figure>
  );
};
